import { Injectable } from '@angular/core';
import { CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router'
import { JwtService } from '../guards/jwt.service';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private jwtService: JwtService){};

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    var tokenValue = this.jwtService.getToken();    
    if (tokenValue)
    {
      return true;
    }
    else
    {
      this.router.navigate(['/authentication/login']);
    }
  }
}


// WEBPACK FOOTER //
// D:/projects/4164_AppsPotr_Backend/production/CMS_prod/src/app/services/authentication/guards/auth-guard.service.ts